import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../App.css';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    try {
      await login(email, password);
      const redirect = searchParams.get('redirect');
      if (redirect && redirect.startsWith('/guest-invite/')) {
        navigate(redirect);
      } else {
        navigate('/dashboard');
      }
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="container" style={{ maxWidth: '400px', marginTop: '100px' }}>
      <div className="card">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img src="/pp-logo.png" alt="Pitch Pilot" style={{ height: '80px', objectFit: 'contain' }} />
          <h2 style={{ marginTop: '10px' }}>Pitch Pilot</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            Login
          </button>
        </form>
        <p style={{ marginTop: '15px', textAlign: 'center' }}>
          Don't have an account? <a href="/register">Register</a>
        </p>
        <div style={{ marginTop: '20px', padding: '15px', background: '#F5F5F5', borderRadius: '8px', fontSize: '14px' }}>
          <strong>Demo Credentials:</strong>
          <br />Player: player1@team.com / player123
          <br />Referee: referee1@league.com / referee123
        </div>
      </div>
    </div>
  );
};

export default Login;

